// source: https://github.com/lukes/ISO-3166-Countries-with-Regional-Codes/tree/master/slim-3
// renamed some of the object properties to title/value to make it easier to move directly
// into a <select> component.
const countries = [
  { label: "Afghanistan", alphathree: "AFG", value: 4 },
  { label: "Åland Islands", alphathree: "ALA", value: 248 },
  { label: "Albania", alphathree: "ALB", value: 8 },
  { label: "Algeria", alphathree: "DZA", value: 12 },
  { label: "American Samoa", alphathree: "ASM", value: 16 },
  { label: "Andorra", alphathree: "AND", value: 20 },
  { label: "Angola", alphathree: "AGO", value: 24 },
  { label: "Anguilla", alphathree: "AIA", value: 660 },
  { label: "Antarctica", alphathree: "ATA", value: 10 },
  { label: "Antigua and Barbuda", alphathree: "ATG", value: 28 },
  { label: "Argentina", alphathree: "ARG", value: 32 },
  { label: "Armenia", alphathree: "ARM", value: 51 },
  { label: "Aruba", alphathree: "ABW", value: 533 },
  { label: "Australia", alphathree: "AUS", value: 36 },
  { label: "Austria", alphathree: "AUT", value: 40 },
  { label: "Azerbaijan", alphathree: "AZE", value: 31 },
  { label: "Bahamas", alphathree: "BHS", value: 44 },
  { label: "Bahrain", alphathree: "BHR", value: 48 },
  { label: "Bangladesh", alphathree: "BGD", value: 50 },
  { label: "Barbados", alphathree: "BRB", value: 52 },
  { label: "Belarus", alphathree: "BLR", value: 112 },
  { label: "Belgium", alphathree: "BEL", value: 56 },
  { label: "Belize", alphathree: "BLZ", value: 84 },
  { label: "Benin", alphathree: "BEN", value: 204 },
  { label: "Bermuda", alphathree: "BMU", value: 60 },
  { label: "Bhutan", alphathree: "BTN", value: 64 },
  {
    label: "Bolivia (Plurinational State of)",
    alphathree: "BOL",
    value: 68,
  },
  {
    label: "Bonaire, Sint Eustatius and Saba",
    alphathree: "BES",
    value: 535,
  },
  { label: "Bosnia and Herzegovina", alphathree: "BIH", value: 70 },
  { label: "Botswana", alphathree: "BWA", value: 72 },
  { label: "Bouvet Island", alphathree: "BVT", value: 74 },
  { label: "Brazil", alphathree: "BRA", value: 76 },
  { label: "British Indian Ocean Territory", alphathree: "IOT", value: 86 },
  { label: "Brunei Darussalam", alphathree: "BRN", value: 96 },
  { label: "Bulgaria", alphathree: "BGR", value: 100 },
  { label: "Burkina Faso", alphathree: "BFA", value: 854 },
  { label: "Burundi", alphathree: "BDI", value: 108 },
  { label: "Cabo Verde", alphathree: "CPV", value: 132 },
  { label: "Cambodia", alphathree: "KHM", value: 116 },
  { label: "Cameroon", alphathree: "CMR", value: 120 },
  { label: "Canada", alphathree: "CAN", value: 124 },
  { label: "Cayman Islands", alphathree: "CYM", value: 136 },
  { label: "Central African Republic", alphathree: "CAF", value: 140 },
  { label: "Chad", alphathree: "TCD", value: 148 },
  { label: "Chile", alphathree: "CHL", value: 152 },
  { label: "China", alphathree: "CHN", value: 156 },
  { label: "Christmas Island", alphathree: "CXR", value: 162 },
  { label: "Cocos (Keeling) Islands", alphathree: "CCK", value: 166 },
  { label: "Colombia", alphathree: "COL", value: 170 },
  { label: "Comoros", alphathree: "COM", value: 174 },
  { label: "Congo", alphathree: "COG", value: 178 },
  {
    label: "Congo, Democratic Republic of the",
    alphathree: "COD",
    value: 180,
  },
  { label: "Cook Islands", alphathree: "COK", value: 184 },
  { label: "Costa Rica", alphathree: "CRI", value: 188 },
  { label: "Côte d'Ivoire", alphathree: "CIV", value: 384 },
  { label: "Croatia", alphathree: "HRV", value: 191 },
  { label: "Cuba", alphathree: "CUB", value: 192 },
  { label: "Curaçao", alphathree: "CUW", value: 531 },
  { label: "Cyprus", alphathree: "CYP", value: 196 },
  { label: "Czechia", alphathree: "CZE", value: 203 },
  { label: "Denmark", alphathree: "DNK", value: 208 },
  { label: "Djibouti", alphathree: "DJI", value: 262 },
  { label: "Dominica", alphathree: "DMA", value: 212 },
  { label: "Dominican Republic", alphathree: "DOM", value: 214 },
  { label: "Ecuador", alphathree: "ECU", value: 218 },
  { label: "Egypt", alphathree: "EGY", value: 818 },
  { label: "El Salvador", alphathree: "SLV", value: 222 },
  { label: "Equatorial Guinea", alphathree: "GNQ", value: 226 },
  { label: "Eritrea", alphathree: "ERI", value: 232 },
  { label: "Estonia", alphathree: "EST", value: 233 },
  { label: "Eswatini", alphathree: "SWZ", value: 748 },
  { label: "Ethiopia", alphathree: "ETH", value: 231 },
  { label: "Falkland Islands (Malvinas)", alphathree: "FLK", value: 238 },
  { label: "Faroe Islands", alphathree: "FRO", value: 234 },
  { label: "Fiji", alphathree: "FJI", value: 242 },
  { label: "Finland", alphathree: "FIN", value: 246 },
  { label: "France", alphathree: "FRA", value: 250 },
  { label: "French Guiana", alphathree: "GUF", value: 254 },
  { label: "French Polynesia", alphathree: "PYF", value: 258 },
  { label: "French Southern Territories", alphathree: "ATF", value: 260 },
  { label: "Gabon", alphathree: "GAB", value: 266 },
  { label: "Gambia", alphathree: "GMB", value: 270 },
  { label: "Georgia", alphathree: "GEO", value: 268 },
  { label: "Germany", alphathree: "DEU", value: 276 },
  { label: "Ghana", alphathree: "GHA", value: 288 },
  { label: "Gibraltar", alphathree: "GIB", value: 292 },
  { label: "Greece", alphathree: "GRC", value: 300 },
  { label: "Greenland", alphathree: "GRL", value: 304 },
  { label: "Grenada", alphathree: "GRD", value: 308 },
  { label: "Guadeloupe", alphathree: "GLP", value: 312 },
  { label: "Guam", alphathree: "GUM", value: 316 },
  { label: "Guatemala", alphathree: "GTM", value: 320 },
  { label: "Guernsey", alphathree: "GGY", value: 831 },
  { label: "Guinea", alphathree: "GIN", value: 324 },
  { label: "Guinea-Bissau", alphathree: "GNB", value: 624 },
  { label: "Guyana", alphathree: "GUY", value: 328 },
  { label: "Haiti", alphathree: "HTI", value: 332 },
  {
    label: "Heard Island and McDonald Islands",
    alphathree: "HMD",
    value: 334,
  },
  { label: "Holy See", alphathree: "VAT", value: 336 },
  { label: "Honduras", alphathree: "HND", value: 340 },
  { label: "Hong Kong", alphathree: "HKG", value: 344 },
  { label: "Hungary", alphathree: "HUN", value: 348 },
  { label: "Iceland", alphathree: "ISL", value: 352 },
  { label: "India", alphathree: "IND", value: 356 },
  { label: "Indonesia", alphathree: "IDN", value: 360 },
  { label: "Iran (Islamic Republic of)", alphathree: "IRN", value: 364 },
  { label: "Iraq", alphathree: "IRQ", value: 368 },
  { label: "Ireland", alphathree: "IRL", value: 372 },
  { label: "Isle of Man", alphathree: "IMN", value: 833 },
  { label: "Israel", alphathree: "ISR", value: 376 },
  { label: "Italy", alphathree: "ITA", value: 380 },
  { label: "Jamaica", alphathree: "JAM", value: 388 },
  { label: "Japan", alphathree: "JPN", value: 392 },
  { label: "Jersey", alphathree: "JEY", value: 832 },
  { label: "Jordan", alphathree: "JOR", value: 400 },
  { label: "Kazakhstan", alphathree: "KAZ", value: 398 },
  { label: "Kenya", alphathree: "KEN", value: 404 },
  { label: "Kiribati", alphathree: "KIR", value: 296 },
  {
    label: "Korea (Democratic People's Republic of)",
    alphathree: "PRK",
    value: 408,
  },
  { label: "Korea, Republic of", alphathree: "KOR", value: 410 },
  { label: "Kuwait", alphathree: "KWT", value: 414 },
  { label: "Kyrgyzstan", alphathree: "KGZ", value: 417 },
  {
    label: "Lao People's Democratic Republic",
    alphathree: "LAO",
    value: 418,
  },
  { label: "Latvia", alphathree: "LVA", value: 428 },
  { label: "Lebanon", alphathree: "LBN", value: 422 },
  { label: "Lesotho", alphathree: "LSO", value: 426 },
  { label: "Liberia", alphathree: "LBR", value: 430 },
  { label: "Libya", alphathree: "LBY", value: 434 },
  { label: "Liechtenstein", alphathree: "LIE", value: 438 },
  { label: "Lithuania", alphathree: "LTU", value: 440 },
  { label: "Luxembourg", alphathree: "LUX", value: 442 },
  { label: "Macao", alphathree: "MAC", value: 446 },
  { label: "Madagascar", alphathree: "MDG", value: 450 },
  { label: "Malawi", alphathree: "MWI", value: 454 },
  { label: "Malaysia", alphathree: "MYS", value: 458 },
  { label: "Maldives", alphathree: "MDV", value: 462 },
  { label: "Mali", alphathree: "MLI", value: 466 },
  { label: "Malta", alphathree: "MLT", value: 470 },
  { label: "Marshall Islands", alphathree: "MHL", value: 584 },
  { label: "Martinique", alphathree: "MTQ", value: 474 },
  { label: "Mauritania", alphathree: "MRT", value: 478 },
  { label: "Mauritius", alphathree: "MUS", value: 480 },
  { label: "Mayotte", alphathree: "MYT", value: 175 },
  { label: "Mexico", alphathree: "MEX", value: 484 },
  {
    label: "Micronesia (Federated States of)",
    alphathree: "FSM",
    value: 583,
  },
  { label: "Moldova, Republic of", alphathree: "MDA", value: 498 },
  { label: "Monaco", alphathree: "MCO", value: 492 },
  { label: "Mongolia", alphathree: "MNG", value: 496 },
  { label: "Montenegro", alphathree: "MNE", value: 499 },
  { label: "Montserrat", alphathree: "MSR", value: 500 },
  { label: "Morocco", alphathree: "MAR", value: 504 },
  { label: "Mozambique", alphathree: "MOZ", value: 508 },
  { label: "Myanmar", alphathree: "MMR", value: 104 },
  { label: "Namibia", alphathree: "NAM", value: 516 },
  { label: "Nauru", alphathree: "NRU", value: 520 },
  { label: "Nepal", alphathree: "NPL", value: 524 },
  { label: "Netherlands", alphathree: "NLD", value: 528 },
  { label: "New Caledonia", alphathree: "NCL", value: 540 },
  { label: "New Zealand", alphathree: "NZL", value: 554 },
  { label: "Nicaragua", alphathree: "NIC", value: 558 },
  { label: "Niger", alphathree: "NER", value: 562 },
  { label: "Nigeria", alphathree: "NGA", value: 566 },
  { label: "Niue", alphathree: "NIU", value: 570 },
  { label: "Norfolk Island", alphathree: "NFK", value: 574 },
  { label: "North Macedonia", alphathree: "MKD", value: 807 },
  { label: "Northern Mariana Islands", alphathree: "MNP", value: 580 },
  { label: "Norway", alphathree: "NOR", value: 578 },
  { label: "Oman", alphathree: "OMN", value: 512 },
  { label: "Pakistan", alphathree: "PAK", value: 586 },
  { label: "Palau", alphathree: "PLW", value: 585 },
  { label: "Palestine, State of", alphathree: "PSE", value: 275 },
  { label: "Panama", alphathree: "PAN", value: 591 },
  { label: "Papua New Guinea", alphathree: "PNG", value: 598 },
  { label: "Paraguay", alphathree: "PRY", value: 600 },
  { label: "Peru", alphathree: "PER", value: 604 },
  { label: "Philippines", alphathree: "PHL", value: 608 },
  { label: "Pitcairn", alphathree: "PCN", value: 612 },
  { label: "Poland", alphathree: "POL", value: 616 },
  { label: "Portugal", alphathree: "PRT", value: 620 },
  { label: "Puerto Rico", alphathree: "PRI", value: 630 },
  { label: "Qatar", alphathree: "QAT", value: 634 },
  { label: "Réunion", alphathree: "REU", value: 638 },
  { label: "Romania", alphathree: "ROU", value: 642 },
  { label: "Russian Federation", alphathree: "RUS", value: 643 },
  { label: "Rwanda", alphathree: "RWA", value: 646 },
  { label: "Saint Barthélemy", alphathree: "BLM", value: 652 },
  {
    label: "Saint Helena, Ascension and Tristan da Cunha",
    alphathree: "SHN",
    value: 654,
  },
  { label: "Saint Kitts and Nevis", alphathree: "KNA", value: 659 },
  { label: "Saint Lucia", alphathree: "LCA", value: 662 },
  { label: "Saint Martin (French part)", alphathree: "MAF", value: 663 },
  { label: "Saint Pierre and Miquelon", alphathree: "SPM", value: 666 },
  {
    label: "Saint Vincent and the Grenadines",
    alphathree: "VCT",
    value: 670,
  },
  { label: "Samoa", alphathree: "WSM", value: 882 },
  { label: "San Marino", alphathree: "SMR", value: 674 },
  { label: "Sao Tome and Principe", alphathree: "STP", value: 678 },
  { label: "Saudi Arabia", alphathree: "SAU", value: 682 },
  { label: "Senegal", alphathree: "SEN", value: 686 },
  { label: "Serbia", alphathree: "SRB", value: 688 },
  { label: "Seychelles", alphathree: "SYC", value: 690 },
  { label: "Sierra Leone", alphathree: "SLE", value: 694 },
  { label: "Singapore", alphathree: "SGP", value: 702 },
  { label: "Sint Maarten (Dutch part)", alphathree: "SXM", value: 534 },
  { label: "Slovakia", alphathree: "SVK", value: 703 },
  { label: "Slovenia", alphathree: "SVN", value: 705 },
  { label: "Solomon Islands", alphathree: "SLB", value: 90 },
  { label: "Somalia", alphathree: "SOM", value: 706 },
  { label: "South Africa", alphathree: "ZAF", value: 710 },
  {
    label: "South Georgia and the South Sandwich Islands",
    alphathree: "SGS",
    value: 239,
  },
  { label: "South Sudan", alphathree: "SSD", value: 728 },
  { label: "Spain", alphathree: "ESP", value: 724 },
  { label: "Sri Lanka", alphathree: "LKA", value: 144 },
  { label: "Sudan", alphathree: "SDN", value: 729 },
  { label: "Suriname", alphathree: "SUR", value: 740 },
  { label: "Svalbard and Jan Mayen", alphathree: "SJM", value: 744 },
  { label: "Sweden", alphathree: "SWE", value: 752 },
  { label: "Switzerland", alphathree: "CHE", value: 756 },
  { label: "Syrian Arab Republic", alphathree: "SYR", value: 760 },
  { label: "Taiwan, Province of China", alphathree: "TWN", value: 158 },
  { label: "Tajikistan", alphathree: "TJK", value: 762 },
  { label: "Tanzania, United Republic of", alphathree: "TZA", value: 834 },
  { label: "Thailand", alphathree: "THA", value: 764 },
  { label: "Timor-Leste", alphathree: "TLS", value: 626 },
  { label: "Togo", alphathree: "TGO", value: 768 },
  { label: "Tokelau", alphathree: "TKL", value: 772 },
  { label: "Tonga", alphathree: "TON", value: 776 },
  { label: "Trinidad and Tobago", alphathree: "TTO", value: 780 },
  { label: "Tunisia", alphathree: "TUN", value: 788 },
  { label: "Turkey", alphathree: "TUR", value: 792 },
  { label: "Turkmenistan", alphathree: "TKM", value: 795 },
  { label: "Turks and Caicos Islands", alphathree: "TCA", value: 796 },
  { label: "Tuvalu", alphathree: "TUV", value: 798 },
  { label: "Uganda", alphathree: "UGA", value: 800 },
  { label: "Ukraine", alphathree: "UKR", value: 804 },
  { label: "United Arab Emirates", alphathree: "ARE", value: 784 },
  {
    label: "United Kingdom of Great Britain and Northern Ireland",
    alphathree: "GBR",
    value: 826,
  },
  { label: "United States of America", alphathree: "USA", value: 840 },
  {
    label: "United States Minor Outlying Islands",
    alphathree: "UMI",
    value: 581,
  },
  { label: "Uruguay", alphathree: "URY", value: 858 },
  { label: "Uzbekistan", alphathree: "UZB", value: 860 },
  { label: "Vanuatu", alphathree: "VUT", value: 548 },
  {
    label: "Venezuela (Bolivarian Republic of)",
    alphathree: "VEN",
    value: 862,
  },
  { label: "Viet Nam", alphathree: "VNM", value: 704 },
  { label: "Virgin Islands (British)", alphathree: "VGB", value: 92 },
  { label: "Virgin Islands (U.S.)", alphathree: "VIR", value: 850 },
  { label: "Wallis and Futuna", alphathree: "WLF", value: 876 },
  { label: "Western Sahara", alphathree: "ESH", value: 732 },
  { label: "Yemen", alphathree: "YEM", value: 887 },
  { label: "Zambia", alphathree: "ZMB", value: 894 },
  { label: "Zimbabwe", alphathree: "ZWE", value: 716 },
];

export default countries;
